/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';

import Header from 'components/header';
import Footer from 'components/footer';
import LiveTicker from 'components/liveTicker';
import Newsletter from 'components/newsletter';
import SideMenu from 'components/sideMenu';

const MainLayout = ({ children }) => (
  <>
    <div style={{ position: 'relative' }}>
      <Header />
      <main>{children}</main>
      <Newsletter />
      <Footer />
    </div>
    <SideMenu />
    <LiveTicker />
  </>
);

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
